window.isRunningDebitDevContainer = true;

// NOTE(mohan): When you share dependencies between apps using module federation, those
// dependencies are loaded asynchronously. To make sure they're loaded before the app
// starts, we introduce an "async boundary" by using this `import`. This delays the app start
// until the async dependencies are loaded.
// See: https://webpack.js.org/concepts/module-federation/#uncaught-error-shared-module-is-not-available-for-eager-consumption
import('@/start-app');
